// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c4640ea3","140":"1e8b6b70","234":"04ab8075","411":"a7325e69","589":"7ecd833a","680":"e032a770","688":"a85b5fea","727":"7b7eca83","794":"7ead319d"}[chunkId] + ".chunk.js";
};